import { READ_WORKER_REPORT_DATA_FAILURE, READ_WORKER_REPORT_DATA_REQUEST, READ_WORKER_REPORT_DATA_SUCCESS, WorkerReportActionTypes, WorkerReportState } from 'store/reducers/types/workerReport/workerReport';

const defaultState: WorkerReportState = {
  isLoading: false,
  errorMessage: ""
};

export default function workerReport(state = defaultState, action: WorkerReportActionTypes): WorkerReportState {
  switch (action.type) {
    case READ_WORKER_REPORT_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_WORKER_REPORT_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_WORKER_REPORT_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};